import {Component, Input, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-notification-popup',
    templateUrl: './notification-popup.component.html',
    styleUrls: ['./notification-popup.component.scss'],
    standalone: false
})
export class NotificationPopupComponent implements OnInit {
  ngOnInit(): void {
    this.buildNotifications()
    this.notifications = this.notifications.reverse()
  }

  @Input() notifications : any[] =[];

  constructor(private translate: TranslateService) {}

  createTitle(notif: any){
    let title: string, link: string;
    switch(notif.type){
      case "WELCOME":
        title = this.translate.instant("globalUi.notifications.welcome")
        break
      case "NEW_ORDER":
        title = this.translate.instant("globalUi.notifications.newOrder")
        link =  `/account/orders/${notif.objectId}`
        break        
      case "ORDER_STATUS_UPDATED":
        title = this.translate.instant("globalUi.notifications.orderStatusUpdated")
        link =  `/account/orders/${notif.objectId}`
        break 
      case "PRODUCT_OUT_OF_STOCK":
        title = this.translate.instant("globalUi.notifications.outOfStock")
        link =  `/cart`
        break
    }
    return [title!, link!]
  }

  buildNotifications(){
    if(this.notifications.length > 0) {
      this.notifications = this.notifications.map(notif => {
        let [title, link] = this.createTitle(notif);
        return {
          ...notif,
          title,
          link
        }
      })
    }
  }

}
